import { currentUserQuery } from "@common/api/users"
import { hasPermission } from "@common/lib/permissions"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { ReadingDialog } from "../-components/reading-form/reading-dialog"

export const Route = createFileRoute(
  "/_layout/aircraft_/$aircraftId/readings/new",
)({
  beforeLoad: async ({ context: { queryClient }, params, search }) => {
    const me = await queryClient.ensureQueryData(currentUserQuery())
    if (!hasPermission(me, "utilization:create")) {
      throw redirect({ to: "/aircraft/$aircraftId", params, search })
    }
  },
  component: NewAircraftReading,
})

function NewAircraftReading(): React.ReactElement {
  const { aircraftId } = Route.useParams()
  return (
    <ReadingDialog
      aircraftId={aircraftId}
      subject={{ kind: "aircraft", aircraftId }}
    />
  )
}
